// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3W8za","noInteraction":"EventWrapper_noInteraction__2VK6m"};